module.exports = __webpack_public_path__ + "img/24.e2cd776b.svg";